module.exports = __webpack_public_path__ + "school/img/videoTrainingDirectory.4693c5e6.jpg";